<template>
  <img
    v-if="src && !error"
    class="object-cover"
    :src="src"
    :alt="alt || 'Avatar'"
    @error="onError"
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

export interface Props {
  src: string
  icon?: string
  alt: string
}

const props = withDefaults(defineProps<Props>(), {
  src: '',
  icon: '',
  alt: ''
})

const error = ref(false)

watch(
  () => props.src,
  () => {
    if (error.value) {
      error.value = false
    }
  }
)

const onError = () => {
  error.value = true
}
</script>
